<template>
  <div class="course-service" ref="courseService">
    <div class="course-service-top">
      <div class="user-img">
        <img
          :src="shopMsg.logo"
          style="border-radius: 50%;height: 50px;width: 50px"
          alt
        />
      </div>
      <div class="top-lf">
        <div class="shop-name">
          <span class="name-text">{{ shopMsg.shopName }}</span
          >的店铺
        </div>
        <div class="has-see">
          <img src="../assets/img/dianpu/icon-yanjing@2x.png" alt />
          <span>{{ shopMsg.browseCount }}次浏览</span>
        </div>
      </div>
    </div>
    <div class="course-advs" v-if="this.slideShow">
      <van-swipe
        class="my-swipe"
        :loop="true"
        :autoplay="2000"
        :show-indicators="false"
        :height="150"
        @change="swipeChange"
      >
        <van-swipe-item
          v-for="(item, index) in list"
          :key="index"
          style="border-radius:10px"
          @click="toAYTest(index)"
        >
          <img
            style="width:100%;height: 100%;border-radius: 10px;"
            :src="item.imgUrl"
            alt=""
          />
        </van-swipe-item>
      </van-swipe>
      <div class="point">{{ swipeIndex + 1 }}/{{ list.length }}</div>
    </div>
    <div class="course-service-main">
      <ly-tab
        id="lyTab"
        v-model="selectedId"
        :items="classNameList"
        :options="tabOptions"
        @change="changeLyTab"
        :offset="50"
        v-if="isShowTab"
      >
      </ly-tab>
      <div class="main-middle" id="main-middle" :style="`height:${this.slideShow ? '88%':'91%'}`">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
          :immediate-check="true"
        >
          <div
            class="course"
            @click="toCourseDetails(item.id)"
            v-for="(item, index) in courseList"
            :key="index"
          >
            <div class="course-rg">
              <img :src="item.thumbnail" alt />
            </div>
            <div class="course-lf">
              <div class="course-lf-top">{{ item.title }}</div>
              <div class="course-lf-middle">
                <div class="tag" v-for="(tag, idx) in item.tags" :key="idx">
                  {{ tag }}
                </div>
              </div>
              <div class="course-lf-bto">
                <div class="price">
                  <span>¥</span>
                  <span>{{ item.promotionPrice }}</span>
                </div>
                <div class="studys">{{ item.learnCnt }}次学习</div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="course-service-bto">
      <div class="teacher" @click="contactTeacher">联系老师</div>
      <div class="teacher share" @click="showShare">分享</div>
    </div>
    <div class="bound" v-if="isContactTeacher">
      <div class="bound-main">
        <img
          src="../assets/img/dianpu/icon-close@2x.png"
          class="close"
          alt=""
          @click="closeContactTeacher"
        />
        <img :src="liaison.headImgUrl" class="touxiang" alt="" />
        <div class="user-name">{{ liaison.nickName }}</div>
        <div class="hint">感兴趣请联系推荐人</div>
        <div
          class="btn"
          v-clipboard="liaison.phone"
          @success="handleCopy(true)"
          @error="handleCopy(false)"
          @click="closeContactTeacher"
        >
          复制微信手机号
        </div>
      </div>
    </div>
    <shareShop v-if="isShowShare" @closeShare="closeShare"></shareShop>
    <div class="guide" v-if="isShowGuide" @click="hideGuide">
      <div class="guide-items" :style="`top:${this.slideShow ? 248 : 76}px;`">
        <img
          class="guide-img"
          src="../assets/images/guide/tabs-guide.png"
          alt=""
        />
        <div class="tabs">
          <ly-tab
            v-model="selectedId"
            :items="classNameList"
            :options="tabOptions"
          >
          </ly-tab>
        </div>
        <div class="mask"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { List, Swipe, SwipeItem, Toast } from "vant";
import shareShop from "../components/popupWindow/shareShop";
import api from "../api/api";
import MtaH5 from "mta-h5-analysis";
import Clipboard from "clipboard";
export default {
  components: {
    shareShop,
  },
  data() {
    return {
      isShowGuide: false, // 是否显示引导
      selectedId: 0, // lytab选项
      classNameList: [], // 分类数组
      // lytab参数
      tabOptions: {
        activeColor: "#333",
      },
      shopId: 0,
      shopMsg: {},
      liaison: {},
      list: [],
      loading: false,
      finished: false,
      courseList: [],
      // 轮播下标
      swipeIndex: 0,
      // 是否联系老师
      isContactTeacher: false,
      // 是否展示分享
      isShowShare: false,
      initIndex: 0,
      initSize: 4,
      //是否展示轮播图
      slideShow: false,
      page: 1,
      categoryId: '',  // 分类id
      finishedText: '已经到底了~',
      isShowTab: false, // 是否显示滑动的tab
      
      isLogin:false,
    };
  },
  async created() {
    document.title = "店铺";
    this.shopId = this.$route.params.shopId || localStorage.getItem("shopId");
    //判断用户是否登录
    await this.getUserInfo()
    this.getShopInfo();
    await this.addVisitLog(this.$route.params.inviteCode);
    MtaH5.pgv();
    this.getShopCategoryList();
  },
  mounted() {
    this.$nextTick(()=>{
      //如果第一次进入，新手指引
      let isShowGuide = localStorage.getItem("isShowGuide");
      if (!isShowGuide) {
        this.isShowGuide = true;
      }
    });
  },
  methods: {
    // 设置分类列表高度
    setMainHeight(){
      this.$nextTick(()=>{
        let dom,dom1,dom2=0,dom3,dom4,height;
        dom = document.querySelector('.course-service').offsetHeight;
        dom1 = document.querySelector('.course-service-top').offsetHeight;
        if(document.querySelector('.course-advs')){
          dom2 = document.querySelector('.course-advs').offsetHeight;
        }
        dom4 = document.querySelector('.course-service-bto').offsetHeight;
        dom3 = document.querySelector('.course-service-main');
        height = dom - (dom1 + dom2 + dom4);
        dom3.style = `height:${height}px`;
      })
    },
    // 切换lyTab
    changeLyTab(item) {
      document.getElementById('main-middle').scrollTo(0,0);
      this.page = 1;
      this.loading = false;
      this.finished = false;
      this.courseList.length = 0;
      this.initIndex = 0;
      this.categoryId = item.id;
      this.getShopClassification();
    },
    // 获取分类名称
    async getShopCategoryList() {
      let params = {
        type: "product_group",
        name: "",
      };
      const res = await api.getShopCategoryList(params);
      if(res.success){
        this.classNameList = res.data.map(item=>{
            item['label'] = item.name;
            return item;
          });
          this.categoryId = this.classNameList[0].id;
          this.isShowTab = true;
          this.getShopClassification();
      }else{
        this.$toast(res.msg);
      }
    },
    // 获取分类的商品数据
    async getShopClassification() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let params = {
        shopId: this.shopId,
        groupId: this.categoryId,
        index: this.initIndex,
        size: this.initSize,
      };
      const res = await api.getShopClassification(params);
      if (res.success) {
        Toast.clear();
        if (res.data.items.length == 0) {
          this.loading = false;
          this.finished = true;
          this.page == 1 ? this.finishedText = '暂无数据!':'';
        } else {
          this.finishedText = '已经到底了~';
          console.log('--前--', this.courseList);
          this.courseList = this.courseList.concat(res.data.items);
          console.log('--后--', this.courseList);
          this.loading = false;
          this.initIndex += 4;
          this.page++;
        }
      } else {
        Toast(res.msg);
      }
    },
    // 隐藏引导
    hideGuide() {
      this.isShowGuide = false;
      localStorage.setItem("isShowGuide", true);
    },
    // 跳转阿姨
    toAYTest(index) {
      if (this.list[index].targetUrl) {
        location.href = this.list[index].targetUrl;
      }
    },
    // 复制成功回调
    handleCopy(sign) {
      sign ? this.$toast("复制成功"):this.$toast("复制失败");
    },
    async onLoad() {
      if (this.page !== 1) {
        this.getShopClassification();
      }
    },
    // 获取商铺信息
    async getShopInfo() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      //获取店铺信息
      let params = {
        shopId: this.shopId,
      };
      //获取店铺信息
      await api
        .getShopInfo(params)
        .then((res) => {
          if (res.success) {
            this.shopMsg = res.data;
            this.shopMsg.browseCount = this.format(res.data.browseCount, 3);
            //是否开启轮播图(后端数据返回)
            if (this.shopMsg.slideShow) {
              let sildeParam = {
                shopId: this.shopId,
                // type: "slide",
              };
              //获取轮播图
              api
                .getSlideShow(sildeParam)
                .then((res) => {
                  if (res.data.length > 0) {
                    this.list = res.data;
                    this.slideShow = true;
                  }
                  this.setMainHeight();
                })
                .catch((res) => {
                  Toast(res.msg);
                  return;
                });
            }
          } else {
            Toast(res.msg);
            return;
          }
        })
        .catch((res) => {
          Toast(res.msg);
          return;
        });
    },
    //浏览次数格式化
    format(num, len) {
      if (len != undefined) {
        return `${num * 1}`.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      } else {
        return `${num * 1}`.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
      }
    },
    swipeChange(index) {
      this.swipeIndex = index;
    },
    // 联系老师
    contactTeacher() {
      let params = {
        shopId: this.shopId,
      };
      api
        .getShopContact(params)
        .then((res) => {
          console.log("res ", res.data);
          if (res.success) {
            this.liaison = res.data;
            this.isContactTeacher = true;
          } else {
            Toast("登录后才能获取联系人，请先登录！");
          }
        })
        .catch((res) => {
          Toast(res.msg);
          return;
        });
    },
    // 关闭联系老师
    closeContactTeacher() {
      //需要复制手机号到剪切板 取值为 this.liaison.phone  (liaison中为联系人信息)
      this.isContactTeacher = false;
    },
    // 展示分享
    showShare() {
      //TODO 验证登录  未登录跳转登录页面
      if(!this.isLogin) {
       this.$dialog
          .confirm({
            title: "温馨提示",
            message: "您还未登录",
            confirmButtonText: "去登录", //改变确认按钮上显示的文字
            //cancelButtonText: "稍后学习" //改变取消按钮上显示的文字
          })
          .then(() => {
            //跳转到登录界面
            wx.miniProgram.navigateTo({
              url:
                "../../login/wxLogin/wxLogin?fromPage=shop&shopId=" +
                this.shopId,
            });
          })
          .catch(() => {
          });
      } else {
        this.isShowShare = true;
      }
    },
    // 关闭分享
    closeShare() {
      this.isShowShare = false;
    },
    // 前往课程详情
    toCourseDetails(productId) {
      let params = {
        shopId: this.shopId,
        productId: productId,
        visite: 1,
      };
      if (
        this.$route.params.inviteCode !== "" &&
        undefined !== this.$route.params.inviteCode
      ) {
        params.inviteCode = this.$route.params.inviteCode;
      }
      this.$router.push({ name: "courseDetails", params: params });
      //离开页面时初始化数据 再次进入时重新加载
      // this.courseList.length = 0;
      // this.initIndex = 0;
      // this.initSize = 10;
      // this.page = 1;
    },
    
    //新增访问记录
    async addVisitLog(visiteCode) {
      let params = {
        shopId: this.shopId,
      };
      //如果存在邀请码 则传入邀请码
      if ("" !== visiteCode && undefined !== visiteCode) {
        params.inviteCode = this.inviteCode;
        //扫码进入店铺埋点事件
        MtaH5.clickStat("qrcode_open_shop", {});
      } else {
        MtaH5.clickStat("open_shop", {});
      }
      await api
        .visitLog(params)
        .then()
        .catch();
    },
    copy(str) {
      let save = function(e) {
        e.clipboardData("text/plain", str);
        e.preventDefault();
      };
      document.addEventListener("copy", save);
      document.execCommand("copy");
    },
    //判断用户是否登录
    async getUserInfo(){
      let that=this
      await api.getUserInfo().then(res=>{
        if(res.success){
          that.isLogin=true
        }else{
          if(res.status==2){
            Toast.clear() //清除提示
          }
        }
      }).catch(err=>{
        return
      })
    }
  },
  
};
</script>

<style lang="scss" scoped>
.course-service {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #f8f8f8;
  .course-service-top {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    background-color: #fff;
    .user-img {
      width: 50px;
      height: 50px;
      img {
        width: 100%;
      }
    }
    .top-lf {
      margin-left: 14px;
      width: 80%;
      .shop-name {
        width: 100%;
        color: #333;
        font-size: 17px;
        font-weight: bold;
        display: flex;
        align-items: center;
        .name-text {
          display: inline-block;
          max-width: 70%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
      .has-see {
        display: flex;
        align-items: center;
        margin-top: 10px;
        img {
          width: 16px;
        }
        span {
          margin-left: 6px;
          font-size: 12px;
          color: #6a6a6a;
        }
      }
    }
  }
  .course-advs {
    position: relative;
    padding: 10px 14px;
    background: #fff;
    .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 150px;
      text-align: center;
      background-color: #39a9ed;
    }
    .van-swipe-item {
      border-radius: 10px;
    }
    .slide-img {
      height: 150px;
      border-radius: 10px;
    }
    .point {
      position: absolute;
      right: 24px;
      bottom: 16px;
      color: #fff;
      font-size: 10px;
      padding: 3px 6px;
      border-radius: 10px;
      background-color: rgba(0, 0, 0, 0.6);
    }
  }
  .course-service-main {
    height: 57%;
    // padding-bottom: 64px;
    .main-top {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 12px 0 18px;
      .course-title {
        color: #666666;
      }
      .active {
        position: relative;
        box-sizing: border-box;
        span {
          color: #333333;
        }
        .under-line {
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 3px;
          background: linear-gradient(270deg, #f74c12 0%, #fd7d32 100%);
          border-radius: 5px;
          margin: 0 auto;
        }
      }
    }
    .main-middle {
      height: 87%;
      overflow: auto;
      padding: 0 8px;
      .course {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        background-color: #fff;
        border-radius: 12px;
        padding: 12px;
        margin-bottom: 12px;
        .course-rg {
          position: relative;
          width: 100px;
          height: 75px;
          border-radius: 4px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            box-shadow: 0px 0px 10px #e9e3e3;
          }
          .rexiao {
            position: absolute;
            top: 0;
            left: 0;
            width: 34px;
            height: 18px;
          }
        }
        .course-lf {
          width: calc(100% - 100px);
          margin-left: 12px;
          .course-lf-top {
            text-align: left;
            color: #333;
            font-weight: bold;
          }
        }
        .course-lf-middle {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 11px;
          .tag {
            width: 46px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            background: #fff2ec;
            border-radius: 4px;
            font-size: 12px;
            color: #ff7303;
          }
          .tag:not(:first-child) {
            margin-left: 4px;
          }
        }
        .course-lf-bto {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 11px;
          .price {
            span {
              font-weight: bold;
              color: #ff5534;
            }
            span:first-child {
              font-size: 14px;
              margin-right: 4px;
            }
          }
          .studys {
            font-size: 12px;
            color: #6a6a6a;
          }
        }
      }
    }
  }
  .course-service-bto {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #fff;
    .teacher {
      width: 140px;
      height: 40px;
      line-height: 40px;
      border-radius: 23px;
      border: 1px solid #ff3f1b;
      color: #ff3f1b;
      font-weight: bold;
      text-align: center;
    }
    .share {
      background-color: #ff6060;
      color: #fff;
    }
  }
  .bound {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.7);
    .bound-main {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18rem;
      padding: 20px;
      background-color: #fff;
      transform: translate(-50%, -50%);
      border-radius: 6px;
      .close {
        position: absolute;
        top: -36px;
        right: 0px;
        width: 27px;
        height: 27px;
      }
      .touxiang {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
      .user-name {
        margin: 10px 0;
      }
      .hint {
        font-size: 14px;
      }
      .btn {
        width: 140px;
        height: 40px;
        background: #ff6060;
        border-radius: 20px;
        margin: 24px auto 0;
        color: #fff;
        line-height: 40px;
        font-size: 14px;
      }
    }
  }
}
::v-deep .ly-tabbar {
  margin-bottom: 8px;
  background-color: #f8f8f8;
  border: 0;
  box-shadow: none;
}
::v-deep .ly-tab-active-bar {
  background: linear-gradient(270deg, #f74c12 0%, #fd7d32 100%);
  border-radius: 5px;
}
::v-deep .ly-tab-item {
  font-size: 15px;
  color: #666666;
  font-weight: 400;
}
::v-deep .van-list{
  padding-bottom: .625rem;
}
.guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  .guide-items {
    position: absolute;
    left: 0;
    z-index: 2;
    width: 100%;
    .guide-img {
      width: 100%;
    }
    .tabs {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 60px;
      background-color: transparent;
      z-index: 100;
    }
  }
}

</style>
